// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5833":"66e8c705","7371":"5605ec3f","9632":"66e8c705"}[chunkId] + ".chunk.css";
};